var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel-primary page",
    attrs: {
      "id": "formBox"
    }
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "novalidate": "",
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control floating-label",
    attrs: {
      "type": "email",
      "data-hint": "Enter your email address.",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v("\n\n          " + _vm._s(_vm.error) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer zztext-right"
  }, [_c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle_reset_request($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.send_forgot
    }
  }, [_vm._v("Reset Password")])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "2em 0 1em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/logo.png"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('span', {
    staticClass: "panel-title"
  }, [_vm._v("Forgot your password?")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e734ba6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/ResetRequest.vue
// module id = 555
// module chunks = 0